(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('analyticsSpend', analyticsSpend);

	analyticsSpend.$inject = ['$scope',  '$timeout', '$rootScope', '$state', '$location', '$experiments', '$filter', 'redirectParamsService',
		'leanFilterService', 'currencyFormatService', 'tableService', 'navigationService', 'pageTimingService', 'site_url',
		'tableRenderService', 'storeService', 'customerSettingService', 'flexColumns'];

	function analyticsSpend($scope,  $timeout, $rootScope, $state, $location, $experiments, $filter, redirectParamsService,
			leanFilterService, currencyFormatService, tableService, navigationService, pageTimingService, site_url,
			tableRenderService, storeService, customerSettingService, flexColumns) {
		var vm = this;
		var unsubscribe;

		var timingCalled = false;
		var getDataCalled = false;
		var showRowsCalled = false;
		var setFirstView = false;
		var reportName = 'Spend analytics: Supplier spend';
		var defaultSortColumn = 'netPPVMonth0';
		var defaultSortDir = 'asc';
		var searchType = 'supplier';
		var rendererParams = {
			currencyFormatter: currencyFormatService,
			state: $state,
			'siteUrl': site_url,
			multiFactory: true
		};

		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var waitForFilterLoad = ($location.search() && $location.search()['drilldown'] === '1' && $location.search()['supplierCode'] !== 'undefined');
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		var reportSettingsName = 'spend-analytics/supplier-spend';
		var extraParams = [];
		vm.buildHeaderMap = {};

		var isItemSpend = $state.current.name === 'app.supply-chain.spend-analytics/item-spend';
		if (isItemSpend) {
			reportSettingsName = 'spend-analytics/item-spend';
			reportName = 'Spend analytics: Item spend';
			extraParams.push({ 'name': 'type', 'value': 'byItem' });
			defaultSortDir = 'asc';
			searchType = 'item';
		} else {
			extraParams.push({ 'name': 'type', 'value': 'bySupplier' });
		}

		var pinnedColumns = [];
		var defaultFilters = [];
		// Extra query params to send to backend in data requests

		// Extra drilldown query params to parse
		vm.reportName = reportName;
		vm.showExcel = true;
		vm.initialLoad = true;
		$scope.useNewExport = true;

		var columns = [];

		$scope.filterService = leanFilterService;

		init();
		var reportGroup = 'spend-analytics';
		var reportKey = isItemSpend ? 'item-spend' : 'supplier-spend';
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: reportName,
			reportUrl: '{0}/SpendAnalyticsReport/' + reportGroup + '/' + reportKey,
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: defaultSortColumn,
			defaultSortDirection: defaultSortDir,
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			searchType: searchType,
			hideSearch: false,
			setColumnDefaults: true,
			hasMandatoryFilters: true,
			waitForFilters: isItemSpend && waitForFilterLoad,
			useReportBuilderForExcel: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.broadcastExcel = broadcastExcel;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedReports') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}


		function broadcastExcel() {
			var excelColumns = columns.concat(pinnedColumns);
			// Add quantity columns for export (not shown in UI but available in export)
			for (var i = 0; i < 26; i++) {
				var timePeriodKey = i < 13 ? 'Month' + (12 - i).toString() : 'FutureMonth' + (i - 13).toString();
				excelColumns.push({ 'id': 'quantity' + timePeriodKey });
			}
			$rootScope.$broadcast('export-excel', {
				columns: excelColumns,
				doChooseColumns: true,
				exportFileName: reportSettingsId ? vm.reportName : undefined
			});
		}

		var userTimingListener = $scope.$on('showRowsCalled', function () {
			showRowsCalled = true;
			submitUserTiming();
		});

		$scope.$on('$destroy', function () {
			userTimingListener();
		});

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams, isFilterChanged) {
			var requestedColumns = columns.concat(pinnedColumns);
			return tableService.postData(params, extraParams, requestedColumns).then(function (response) {
				if (!reportSettingsId && !setFirstView) {
					var firstViewObj = {
						'viewType': $state.current.data.viewType
					};
					navigationService.setFirstView(firstViewObj, reportSettingsName);
					setFirstView = true;
				}

				if ((isFilterChanged && isFilterChanged === 'filtersChanged') || vm.initialLoad) {
					if (vm.initialLoad) {
						vm.initialLoad = false;
					}
					changeColumnDisplay(response);
					response.refreshMeta = true;
				}
				getDataCalled = true;
				submitUserTiming();
				return response;
			});
		}

		function submitUserTiming() {
			if (getDataCalled && showRowsCalled && !timingCalled) {
				pageTimingService.submitUserTiming('Shortages by Item');
				timingCalled = true;
			}
		}

		function getColumn(columnId, monthId, renderer, disabled, show, isReverseSort) {
			return {
				'id': columnId + monthId,
				'display': '',
				'width': 180,
				'enablePinning': false,
				'renderer': renderer,
				'type': columnId,
				'show': show,
				'disabled': disabled,
				'isReverseSort': !!isReverseSort
			};
		}

		function disableTimePeriodColumns() {
			columns.forEach(function (col) {
				if (col.id.indexOf('Month') > -1) {
					col.disabled = true;
				}
			});
		}

		function enableColumn(columnId, monthId, headerClass, monthlyStartDate, isFuture, headerDisplayValue, totals) {
			var id = columnId + monthId;
			var keyMap = {
				'spend': 'spend',
				'savingsBaseline': 'savings',
				'increaseBaseline': 'increase',
				'netPPV': 'gainloss'
			};
			var totalKey = keyMap[columnId] + (isFuture ? 'Future' : '');
			var totalVal = totals[totalKey] ? totals[totalKey] : 0;
			if (columnId === 'netPPV' && totalVal !== 0) {
				totalVal *= -1;
			}
			var monthValue = $filter('date')(monthlyStartDate, 'MMM yyyy').toUpperCase();
			updateColumn(id, {
				disabled: false,
				customHeaderClass: headerClass,
				display: monthValue + (!isFuture ? ' ' : ' Future ') + headerDisplayValue + ' </br>' + (currencyFormatService.getWithParametersNegativeSign(totalVal, 0, vm.targetCurrency)),
				displayText: monthValue + (!isFuture ? ' ' : ' Future ') + headerDisplayValue
			});
		}

		function changeColumnDisplay(response) {
			if (!response[0]) {
				return;
			}
			if (response[0] && response[1] && response[0].data.length !== 0) {
				disableTimePeriodColumns();
				tableRenderService.clearSpendSummaryHeaderMap();
				vm.headerTotals = response[0].headerTotals;
				vm.targetCurrency = response[0].targetCurrency;
				vm.responseTotal = response[1];
				vm.timePeriods = response[0].timePeriods;
				//vm.headerTotals = _.sortBy(vm.headerTotals, 'name');
				rendererParams['headerTotals'] = vm.headerTotals;
				updateHeaderTotals();
				var useAlternateHeaderClass = true;
				var headerClass = '';
				for (var i = 0; i < vm.timePeriods.length; i++) {
					var isFuture = _.startsWith(vm.timePeriods[i].key, 'Future');
					var substringStart = isFuture ? 11 : 5;
					var index = parseInt(vm.timePeriods[i].key.substring(substringStart));
					var colTotals = {};
					if  (vm.headerTotals && vm.headerTotals.headerTotalsMonthly && vm.headerTotals.headerTotalsMonthly.length) {
						colTotals = vm.headerTotals.headerTotalsMonthly[index];
					}
					var key = vm.timePeriods[i].key;
					var monthlyStartDate = vm.timePeriods[i].monthlyStartDate;
					headerClass = useAlternateHeaderClass ? 'alternate': '';
					enableColumn('spend', key, headerClass, monthlyStartDate, isFuture, 'Spend', colTotals);
					enableColumn('savingsBaseline', key, headerClass, monthlyStartDate, isFuture, 'Savings', colTotals);
					enableColumn('increaseBaseline', key, headerClass, monthlyStartDate, isFuture, 'Increase', colTotals);
					enableColumn('netPPV', key, headerClass, monthlyStartDate, isFuture, 'Net PPV', colTotals);
					useAlternateHeaderClass = !useAlternateHeaderClass;
				}
			}
		}

		function getHeaderTotal(headerId) {
			var result = 0;
			var headerTotals = vm.headerTotals;
			var targetCurrency = vm.targetCurrency;

			if (headerId && _.indexOf(['totalSpendCurrentFiscalYear', 'ppvCurrentFiscalYear', 'totalSpendPreviousFiscalYear', 'ppvPreviousFiscalYear', 'futurePoOverStdPriceValue'], headerId) >= 0) {
				if (!headerTotals || typeof headerTotals[headerId] === 'undefined') {
					return '';
				}
				return currencyFormatService.getWithParametersNegativeSign(headerTotals[headerId], 0, targetCurrency);
			}

			return currencyFormatService.getWithParametersNegativeSign(result, 0, targetCurrency);
		}

		function updateColumn(colId, changes) {
			var column = columns.find(function (col) {
				return col.id === colId;
			}) || pinnedColumns.find(function (col) {
				return col.id === colId;
			});
			if (column) {
				column = Object.assign(column, changes);
			}
		}

		function updateHeaderTotals() {
			var totalSpendCurrentFiscalYear = getHeaderTotal('totalSpendCurrentFiscalYear');
			var ppvCurrentFiscalYear = getHeaderTotal('ppvCurrentFiscalYear');
			var totalSpendPreviousFiscalYear = getHeaderTotal('totalSpendPreviousFiscalYear');
			var ppvPreviousFiscalYear = getHeaderTotal('ppvPreviousFiscalYear');
			var futurePoOverStdPriceValue = getHeaderTotal('futurePoOverStdPriceValue');
			if (isItemSpend) {
				updateColumn('totalSpendCurrentFiscalYear', { 'display': 'Spend Current Fiscal Year<br/>' + totalSpendCurrentFiscalYear});
				updateColumn('ppvCurrentFiscalYear', { 'display': 'PPV Current Fiscal Year<br/>' + ppvCurrentFiscalYear });
				updateColumn('totalSpendPreviousFiscalYear', { 'display': 'Spend Previous Fiscal Year<br/>' + totalSpendPreviousFiscalYear });
				updateColumn('ppvPreviousFiscalYear', { 'display': 'PPV Previous Fiscal Year<br/>' + ppvPreviousFiscalYear });
				updateColumn('futurePoOverStdPriceValue', { 'display': 'Future PPV<br/>' + futurePoOverStdPriceValue });
			} else {
				updateColumn('totalSpendCurrentFiscalYear', { 'display': 'Spend Current Fiscal Year<br/>' + totalSpendCurrentFiscalYear });
				updateColumn('ppvCurrentFiscalYear', { 'display': 'PPV Current Fiscal Year<br/>' + ppvCurrentFiscalYear });
				updateColumn('totalSpendPreviousFiscalYear', { 'display': 'Spend Previous Fiscal Year<br/>' + totalSpendPreviousFiscalYear });
				updateColumn('ppvPreviousFiscalYear', { 'display': 'PPV Previous Fiscal Year<br/>' + ppvPreviousFiscalYear });
				updateColumn('futurePoOverStdPriceValue', { 'display': 'Future PPV<br/>' + futurePoOverStdPriceValue });
			}
		}

		function setDefaultColumns() {

			if (isItemSpend) {
				columns.push({ 'id': 'actionStatus', 'display': 'Task Status', 'renderer': tableRenderService.status, 'sort': false});
				columns.push({ 'id': 'itemCode', 'display': 'Item', 'class': 'itemCodeCell', 'renderer': tableRenderService.itemCode, 'sort': true, 'width': 150});
				columns.push({ 'id': 'factoryName', 'display': 'Site', 'class': 'supplierCell', 'active': true, 'title': '', 'sort': false, 'width': 150});
				columns.push({ 'id': 'supplierName', 'display': 'Supplier', 'width': 150});
				columns.push({ 'id': 'supplierCode', 'display': 'Supplier Code', 'width': 150});
				columns.push({ 'id': 'buyerCode', 'display': 'Buyer', 'width': 140, 'show': false});
				columns.push({ 'id': 'itemGroup', 'display': 'Item Group', 'width': 150});
				columns.push({ 'id': 'materialGroup', 'display': 'Material Group', 'width': 150});
				columns.push({ 'id': 'materialType', 'display': 'Material Type', 'width': 150});
				columns.push({ 'id': 'currentOnHand', 'display': 'On Hand', 'renderer': tableRenderService.currency, 'width': 100});
				columns.push({ 'id': 'currentOnOrder', 'display': 'On Order', 'renderer': tableRenderService.currency, 'width': 100});
				columns.push({ 'id': 'totalSpendCurrentFiscalYear', 'displayText': 'Spend Current Fiscal Year','display': 'Spend Current Fiscal Year<br/>', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'ppvCurrentFiscalYear', 'displayText':  'PPV Current Fiscal Year', 'display': 'PPV Current Fiscal Year<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
				columns.push({ 'id': 'standardPriceCurrentFiscalYear', 'display': 'Baseline Price Current FY', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'totalSpendPreviousFiscalYear', 'displayText': 'Spend Previous Fiscal Year', 'display': 'Spend Previous Fiscal Year<br/>', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'ppvPreviousFiscalYear', 'displayText': 'PPV Previous Fiscal Year', 'display': 'PPV Previous Fiscal Year<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
				columns.push({ 'id': 'standardPricePreviousFiscalYear', 'display': 'Baseline Price Previous FY', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'futurePoOverStdPriceValue', 'displayText': 'Future PPV', 'display': 'Future PPV<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
				columns = flexColumns.addFlexColumnsBySourceType(['item'], columns);
			} else {
				columns.push({ 'id': 'supplierName', 'display': 'Supplier', 'renderer': tableRenderService.spendAnalyticsIdentifierRenderer, 'width': 300});
				columns.push({ 'id': 'supplierCode', 'display': 'Supplier Code', 'width': 150});
				columns.push({ 'id': 'countItems', 'display': 'Item Count', 'renderer': tableRenderService.integer, 'width': 80});
				columns.push({ 'id': 'averageLeadTimeDays', 'display': 'Avg Lead Time', 'renderer': tableRenderService.integer, 'width': 80});
				columns.push({ 'id': 'currentOnHand', 'display': 'On Hand', 'renderer': tableRenderService.currency, 'width': 100});
				columns.push({ 'id': 'currentOnOrder', 'display': 'On Order', 'renderer': tableRenderService.currency, 'width': 100});
				columns.push({ 'id': 'totalSpendCurrentFiscalYear', 'displayText': 'Spend Current Fiscal Year', 'display': 'Spend Current Fiscal Year<br/>', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'ppvCurrentFiscalYear', 'displayText':  'PPV Current Fiscal Year', 'display': 'PPV Current Fiscal Year<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
				columns.push({ 'id': 'totalSpendPreviousFiscalYear', 'displayText':  'Spend Previous Fiscal Year', 'display': 'Spend Previous Fiscal Year<br/>', 'renderer': tableRenderService.currency, 'width': 150});
				columns.push({ 'id': 'ppvPreviousFiscalYear', 'displayText':  'PPV Previous Fiscal Year', 'display': 'PPV Previous Fiscal Year<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
				columns.push({ 'id': 'futurePoOverStdPriceValue', 'displayText':  'Future PPV', 'display': 'Future PPV<br/>', 'renderer': tableRenderService.ppvRenderer, 'width': 150});
			}
			for (var i = 0; i < 26; i++) {
				var timePeriodKey = i < 13 ? 'Month' + (12 - i).toString() : 'FutureMonth' + (i - 13).toString();
				columns.push(getColumn('spend', timePeriodKey, tableRenderService.analyticsSpendRenderer, true, false));
				columns.push(getColumn('savingsBaseline', timePeriodKey, tableRenderService.analyticsSpendRenderer, true, false));
				columns.push(getColumn('increaseBaseline', timePeriodKey, tableRenderService.analyticsSpendRenderer, true, false));
				columns.push(getColumn('netPPV', timePeriodKey, tableRenderService.analyticsSpendRenderer, true, true, true));
			}
		}

		function processSpendAnalyticsReport() {
			$scope.filterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.includeInFilter = true;
			siteFilter.removable = false;
			
			var filters = {};
			filters.multiSelectFilters = [
				$scope.filterService.filterDefinitions['BusinessUnit'],
				$scope.filterService.filterDefinitions['Division'],
				$scope.filterService.filterDefinitions['Entity'],
				siteFilter,
				$scope.filterService.filterDefinitions['SpendType']
			];
			defaultFilters = [
				{ 'id': 'startMonth', 'values': ['Month2'] },
				{ 'id': 'itemGroupNdx', 'values': [$scope.filterService.leanDnaAllSelected] }
			];
			if (isItemSpend) {
				defaultFilters.push({ 'id': 'supplierNdx', 'values': [$scope.filterService.leanDnaAllSelected] });
				var qParams = parseQueryString(window.location.href);
				if (!(qParams['entity'] || qParams['businessunit'] || qParams['division'] || qParams['indirectSpendFlag'] || qParams['spendType'])) {
					defaultFilters.push({ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true });
				}
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['Supplier']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['Buyer']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['MaterialGroup']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['MaterialType']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['Item Group']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['EndItem']);
			} else {
				defaultFilters.push({ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true });
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['Item Group']);
				filters.multiSelectFilters.push($scope.filterService.filterDefinitions['Supplier']);
			}

			filters.singleSelectFilters = [];
			if (globalConfig.factory.hasPPI) {
				filters.singleSelectFilters.push($scope.filterService.filterDefinitions['BaselinePrice']);
			}
			filters.rangeFilters = [$scope.filterService.filterDefinitions['SpendAnalyticsTimePeriod']];
			if (isItemSpend) {
				filters = $scope.filterService.addFlexFiltersBySourceType(['item'], filters);
			}
			$scope.filterService.setAllFilterLists(filters);
		}

		function init() {
			// This check make sures, if new customer setting is set in the global config or not
			setDefaultColumns();
			if (typeof globalConfig.factory.hasPPI === 'undefined') {
				customerSettingService.getCustomerSettings('doSpendCalculationBasedOnLastPoPrice').then(function(response){
					if (response) {
						globalConfig.factory.hasPPI = response.doSpendCalculationBasedOnLastPoPrice;
					} else {
						globalConfig.factory.hasPPI = false;
					}
					processSpendAnalyticsReport();
				});
			} else {
				processSpendAnalyticsReport();
			}

		}
	}
})();
